import { render, staticRenderFns } from "./RuleForm.vue?vue&type=template&id=58640b00&scoped=true"
import script from "./RuleForm.vue?vue&type=script&lang=js"
export * from "./RuleForm.vue?vue&type=script&lang=js"
import style0 from "./RuleForm.vue?vue&type=style&index=0&id=58640b00&prod&lang=css"
import style1 from "./RuleForm.vue?vue&type=style&index=1&id=58640b00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58640b00",
  null
  
)

export default component.exports